import Breadcrumb from "./components/Breadcrumb";
import { BannerComponent } from "../../components";
import FeedBBackContent from "./components/FeedBackContent";
function FeedBack() {
  return (
    <div className="feedback">
      <BannerComponent />
      <Breadcrumb />
      <FeedBBackContent />
    </div>
  );
}
export default FeedBack;
